import TranslatedTextareaControl, {
    getInitialTextareaTranslationState
} from "./translated-textarea-control";

export {
    getInitialTextareaTranslationState
};

export default TranslatedTextareaControl;
